import { Application } from "@hotwired/stimulus"
import { Tabs } from "tailwindcss-stimulus-components"

const application = Application.start()

application.register('tabs', Tabs)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
